import * as React from 'react';
import { useFormikContext } from 'formik';

import { Button } from 'components/bootstrap';
import { Row } from 'common/components/layout-styles';
import type {
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';

type Props = {
  isEdit?: boolean;
  saving?: boolean;
  onRemove: () => void;
  onCancel?: () => void;
};

function FormButtons({ onRemove, isEdit = false, saving = false, onCancel = undefined }: Props) {
  const { resetForm, isValid, dirty, submitForm } =
    useFormikContext<EventProceduresAPIType<Array<EventProcedureStepAPIType>>>();

  const handleOnCancel = React.useCallback(() => {
    resetForm();
    onCancel?.();
  }, [onCancel, resetForm]);

  return (
    <Row $justify="flex-end">
      <Button type="reset" onClick={handleOnCancel}>
        Cancel
      </Button>
      {isEdit && (
        <Button bsStyle="danger" onClick={onRemove}>
          Remove
        </Button>
      )}
      <Button type="button" bsStyle="primary" onClick={submitForm} disabled={!isValid || !dirty || saving}>
        {isEdit ? 'Save' : 'Create'} Event Procedure
      </Button>
    </Row>
  );
}

export default FormButtons;
